var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('a-tabs', {
    staticClass: "announce-tabs",
    attrs: {
      "animated": false
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.activeTab,
      callback: function ($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_vm._l(_vm.tabList, function (item) {
    return [_c('a-tab-pane', {
      key: item.value,
      attrs: {
        "id": item.id,
        "tab": _vm.t(item.text)
      }
    })];
  })], 2), _c(_vm.activeTab, {
    tag: "component"
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };